export default __webpack_public_path__ + "images/Axial_View_of_Kidneys.5fa0c78fe3790bc8ace3f07663223359.png";